import { RewardRule } from '../../../../rewards/models/rewards-v2.models';
import { formatRewardsRuleAmount } from '../../../../rewards/utils/rewards-currency.util';

/** Single rule line, e.g. "$5 per Membership sold" or "$50 for every 50 Membership sold". */
export function formatAdminRewardCriteriaLine(rule: RewardRule): string {
  const amount = formatRewardsRuleAmount(rule.amount);
  const name = rule.name;

  if (Number(rule.items_sold) === 1) {
    return `${amount} per ${name} sold`;
  }

  return `${amount} for every ${rule.items_sold} ${name} sold`;
}

/** All active rules joined with " | ". */
export function formatAdminRewardCriteria(rules: RewardRule[]): string {
  return rules.map(formatAdminRewardCriteriaLine).join(' | ');
}
